<template>
    <div class="container">
        <a-tree-select
            show-search
            class="treeSelect"
            :value="tucengValue"
            size='small' 
            :getPopupContainer = "prpupContainer"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="projectList"
            :replaceFields="replaceFields"
            :treeDefaultExpandedKeys='treeDefaultExpandedKeys'
            :treeNodeFilterProp='"title"'
            @change='selectLayer'>
          </a-tree-select>
    </div>
</template>
     
<script>
    import axios from 'axios'
    import 'proj4leaflet'
    const esri = require('esri-leaflet') 
     export default {
       name: 'selectTcComponent',
       props:{
        map:{
            
        },
        selectLayerBsm:{ 
            type:String,
            default:""
        },
        title:{
            type:String,
            default:""           
        },
        projectList:{
            type:Array,
            default:[]
        }
       },
       data() {
         return {
            // projectList:[],
            myLayer:null,
            tucengValue:'',
            // tucengValue:'5540539e-62b9-4816-aa42-8e633310b689',
            currentProjectInfo:null,
            replaceFields: {
                children: 'children',
                title: 'dataName',
                key: 'bsm',
                value: 'bsm'
            },
            treeDefaultExpandedKeys:[],
            hturl:{
                // 根据资源类型获取对应图层
                getLayersData:'/gisproject/zcqc/getLayersByZylx',
                // 根据图层Id查询报表数据
                getReportsById: "/layerReport/getReportsByLayerId",
            }  
         }
       },
       mounted(){
        // this.loadTcData()
       },
       watch:{
            selectLayerBsm: {
                handler(val,oldValue) {
                    // console.log('监听 新',val);
                    // console.log('监听 旧',oldValue);
                    this.tucengValue = val ? val : ''
                },
                immediate:true
            },
            title:{
                handler(val,oldValue) {
                }, 
            }  
        },
       methods: {
            // 加载图层数据（geojson)
            // loadTcData(){
            // let obj = {}
            // obj.zylx = '1'
            // getAction(this.hturl.getLayersData,obj,null).then(res => {
            //     console.log('查询到的图层数据',res)
            //     if(res.code == 0){
            //         this.projectList = res.data
            //     }else{
            //         this.$message.warning(res.msg)
            //     }
            // })
            // },

            // 查询图层信息(arcgis)
            // loadProjectByNo () {
            //     getGISProjectByNo({ projectNo: 'zcqcgis' }).then(res => {
            //     if (res.success) {
            //         var newArry = []
            //         var gisArry = JSON.parse(JSON.stringify(res.result.serviceList[0].gisLayers))
            //         for(var item of gisArry){
            //             if(item.childLayers && item.childLayers.length > 0 && !item.parentBsm){
            //                 // item.disabled = true
            //                 newArry.push(item)
            //             }
            //         }
            //         this.projectList = newArry
            //         // this.showGeoJsonLayer('e0e83650-2f03-4e59-ada8-5715f54ef920')
            //     }
            //     })
            // },
            prpupContainer () {
                return document.querySelector('.ant-modal-body,.tdfxhzClass') // ID是页面滚动的那个ID，根据自己来
            },
            selectLayer(value,label,extra){
                console.log(value,label,extra,'valuevaluevalue')
                // var allLayers = this.map.getLayers()
                // if(allLayers.length > 0){
                //     for(var item of allLayers){
                //         this.map.removeLayer(item) 
                //     } 
                // }           
                this.tucengValue = value
                let node = extra.triggerNode.$vnode.data.props.dataRef
                this.$emit('getLayerData',node)
                // this.showGeoJsonLayer(value)
            },
            showGeoJsonLayer(value) {
                // 根据value匹配图层并显示
                // let serviceUrl = ''  // 选中的图层的url
                // let layerId = ''  // 选中的图层的id
                // // 先找到编号所在的图层
                // console.log('所有图层',this.map.allLayers);
                // let mapperLayer = this.map.allLayers.find((item, index, arr) => {
                //     return item.key === value
                // })
                // if(mapperLayer){
                //     console.log('mapperLayer',mapperLayer);
                //     serviceUrl = mapperLayer.serviceUrl
                //     layerId = mapperLayer.id
                //     //找到所在map图层
                //     let parnetLayer = this.map.getLayerById(mapperLayer.serviceBsm)
                //     parnetLayer.options.layersArr= [mapperLayer.id]
                //     parnetLayer.setOptions({ layers: parnetLayer.options.layersArr.toString() })
                //     parnetLayer.show = true
                //     // 获取其他图层，隐藏
                //     let layers = this.map.getLayers().filter(e => e.options.id != mapperLayer.serviceBsm)
                //     if(layers.length > 0){
                //         layers.map(item => {
                //             item.show = false
                //         })
                //     }
                // }

                // esri.find({
                //         url: `http://192.168.1.12:6080/arcgis/rest/services/RDDLTB/MapServer/0`
                //         // url: `${serviceUrl}/${layerId}`
                //     })
                //     .layers('all')
                //     .contains(false)
                //     .run((error, featureCollection, response) => {
                //         this.$emit('getLayerData',response.fields,this.tucengValue)
                //         // console.log('response',response);
                //         var wkid = response.extent.spatialReference.wkid  // 参考系
                //         var xyMin = [response.extent.xmin,response.extent.ymin]
                //         var xyMax = [response.extent.xmax,response.extent.ymax]
                //         // 4326参考系明细
                //         let toProjection = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs"
                //         // 4528参考系明细
                //         let fromProjection = "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=GRS80 +units=m +no_defs"
                //         let xyMinLnglat = proj4(fromProjection, toProjection, xyMin);
                //         let xyMaxLnglat = proj4(fromProjection, toProjection, xyMax);
                //         var extent = { 
                //             xmin:xyMinLnglat[0],
                //             xmax:xyMaxLnglat[0],
                //             ymin:xyMinLnglat[1],
                //             ymax:xyMaxLnglat[1] 
                //         }
                //         this.map.flyToExtent(extent, {duration:0.5,scale:1.5} )
                //         this.$bus.$emit('changeCheckedLayers',this.map)
                //     })

                // 优化写法
                let url = `http://192.168.1.12:6080/arcgis/rest/services/RDDLTB/MapServer/0?f=pjson`
                axios.get(url).then(res => {
                    this.$emit('getLayerData',res.data.fields,this.tucengValue)
                    // var lnglat = transformCrsCoordinate(res.data.extent, res.data.extent.spatialReference.latestWkid)
                    // this.map.flyToExtent(lnglat, {duration:0.8,scale:1.2} )
                    // this.$bus.$emit('changeCheckedLayers',this.map)
                })
                
            //     this.myLayer = new mars3d.layer.ArcGisLayer({
            //         id: value,
            //         name: '测试',
            //         usePreCachedTilesIfAvailable: false,
            //         layers: '0',
            //         url: 'http://192.168.1.12:6080/arcgis/rest/services/RDDLTB/MapServer',
            //         flyTo: false,
            //         highlight:{
            //             outline:true,  // 展示边框线
            //             outlineColor:'#3388ff',
            //             outlineWidth:'3',
            //             fill:true,
            //         },
            //         // popup: 'all',  // 弹出框展示所有信息
            //         // 当气泡窗口有部分在地图之外时是否自动进行居中 （目前仅俯视时准确定位）
            //         // popupOptions:{
            //         //   autoCenter:true,
            //         // },
            //         show: true,
            //         // allowDrillPick:true
            //     })
            //    this.map.addLayer(this.myLayer)
            },

        // 获取可飞入的图层数据
        interLayerData(bsm,type){
            const query = esri.query({
                url: `http://192.168.1.12:6080/arcgis/rest/services/RDDLTB/MapServer/0/query`
                })
                let queryWhere = "BSM='" + bsm + "'"
                query.where(queryWhere).run((error, results, response) => {
                if (error) {
                    console.log(error)
                    return
                }
                if(results){
                    if(results && results.features.length > 0){
                        if(type == '1'){
                            this.reLoadGraphic()
                            if(this.graphicLayer){
                                this.addDemoGraphic1(this.graphicLayer,results.features[0].geometry.coordinates)
                                this.map.flyToPositions(results.features[0].geometry.coordinates[0],{
                                    scale:'4'
                                })
                            }
                        }else{
                            this.$refs.marsModal.showModal(results.features[0].properties)
                        }
                    }
                }
            })
        },
       }
     }
     </script>
     
     <style lang="less" scoped>
   .container{
       width: 100%;
       height: 100%;
       .treeSelect{
            width: 100% !important;
            // margin-top: 5px;
            color: #FFFFFF !important;
        }
   }
   /deep/ .ant-select-selection__rendered,
   /deep/ .ant-select-selection--single {
    height: 31px;
    line-height: 31px;
   }
     </style>
     